import "@fortawesome/fontawesome-pro/js/solid.js";
import "@fortawesome/fontawesome-pro/js/fontawesome.js";
import "@fortawesome/fontawesome-pro/js/brands.js";

import navbarInit from "./navbar";
import calendarInit from "./appointment";
import stickyPopupInit from "./sticky-popup";
import youtubeIframesInit from "./youtube-iframe";
import sliderInit from "./swiper";
import heroInit from "./hero";
import lightboxInit from "./lightbox";
import dateInit from "./datepicker";

document.addEventListener("DOMContentLoaded", () => {
  const navItemParents = document.querySelectorAll<HTMLElement>(
    ".navbar__item--parent"
  );
  const gallery = document.querySelector<HTMLElement>(
    ".hexon-single__gallery--slider"
  );

  const calendars = document.querySelectorAll<HTMLElement>(".garage-calendar");
  const stickyPopups = document.querySelectorAll<HTMLElement>(".sticky-popup");
  const youtubeIframes = document.querySelectorAll<HTMLElement>("iframe[src*='youtube.com'], iframe[data-src*='youtube.com']");
  const sliders = document.querySelectorAll<HTMLElement>(".swiper");
  const hero = document.querySelectorAll<HTMLElement>(
    ".garage-hero__background"
  );
  const datecalendars = document.querySelectorAll<HTMLElement>(".date-picker");

  if (navItemParents.length) {
    navItemParents.forEach((navItemParent) => {
      navbarInit(navItemParent);
    });
  }

  if (sliders.length) {
    sliders.forEach((slider) => {
      sliderInit(slider);
    });
  }

  if (hero.length) {
    hero.forEach((slider) => {
      heroInit(slider);
    });
  }

  if (datecalendars.length) {
    datecalendars.forEach((datecalendar) => {
      dateInit(datecalendar);
    });
  }

  if (calendars.length) {
    calendars.forEach((calendar) => {
      calendarInit(calendar);
    });
  }

  if (stickyPopups.length) {
    stickyPopups.forEach((stickyPopup) => {
      stickyPopupInit(stickyPopup);
    });
  }

  if (youtubeIframes.length) {
    youtubeIframes.forEach((iframe) => {
      youtubeIframesInit(iframe);
    });
  }

  if (gallery !== undefined) {
    const mql = window.matchMedia("(max-width: 1024px)");

    if (mql.matches === true) {
      lightboxInit(gallery);
    }
  }

  const body = document.querySelector('body') as HTMLElement;
  const urlParams = new URLSearchParams(window.location.search);
  const actionParam = urlParams.get('flow_action');

  if (body.classList.contains('single-garage') && actionParam == 'open_ext_planner') {
    openModal();
  }
});
